import * as React from 'react';
import { connect } from 'react-redux';
import { __ } from 'react-i18n';
import { Link } from 'react-router';
import styled from 'styled-components';
import { onlyPublic } from '../../utilities/only-public';

import { Title } from 'eshop-defaults';
import { ButtonPrimary } from 'eshop-defaults';
import { Loader } from 'eshop-defaults';

interface State {
  loading: boolean;
  message: string;
  success: boolean;
}

interface Props {
  API: any;
  params: {
    code: string;
  };
}

class Activation extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      message: '',
      success: false,
    };

    const { API } = this.props;
    API.activateUser({
      activationCode: props.params.code,
    })
      .then(() => {
        this.setState({
          loading: false,
          message: __(
            'Aktivácia prebehla úspešne. Pre pokračovanie sa prosím prihláste.',
          ),
          success: true,
        });
      })
      .catch(err => {
        this.setState({
          loading: false,
          message: __(
            'Pri aktivácií účtu nastala neznáma chyba. Skúste to prosím znova neskôr.',
          ),
          success: false,
        });
      });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loading === true && (
          <Loader
            dim={false}
            style={{ marginTop: '100px', paddingBottom: '50px' }}
            loading={true}
          />
        )}
        <AuthContainer>
          {this.state.loading === false &&
            this.state.message && <Title>{this.state.message}</Title>}

          {this.state.loading === false &&
            this.state.success === true && (
              <Link
                to={__('routes:prihlasenie')}
                style={{ textDecoration: 'none' }}
              >
                <ButtonPrimary
                  style={{
                    width: '70%',
                    marginLeft: '15%',
                  }}
                >
                  {__('Prihlásiť sa')}
                </ButtonPrimary>
              </Link>
            )}
        </AuthContainer>
      </React.Fragment>
    );
  }
}

const AuthContainer = styled.div`
  margin-top: 80px;
  width: 40%;
  margin-left: 30%;
  margin-bottom: 80px;
  text-align: center;

  @media only screen and (max-width: 550px) {
    width: 80%;
    margin-left: 10%;
  }
`;

export default onlyPublic(connect()(Activation));
